type IdentityProvider = {
  id: string;
  name: string;
  // the docs link for configuring the idp
  docs: string;
  // some providers require a url, meaning they won't work unless one is provided
  // some providers, like gitlab, have a default url, but can work with one if one
  // is provided, and some, like google, don't use urls at all (though in practice
  // pomerium can still use a custom url, primarily for integration tests, hence
  // the terminology "restricted")
  providerUrl: "allowed" | "required" | "restricted";
};

const docsLink = (slug: string): string => {
  return new URL(
    slug,
    "https://www.pomerium.com/docs/integrations/user-identity/",
  ).toString();
};

export const IdentityProviders: IdentityProvider[] = [
  {
    id: "apple",
    name: "Apple",
    docs: docsLink("apple"),
    providerUrl: "restricted",
  },
  {
    id: "auth0",
    name: "Auth0",
    docs: docsLink("auth0"),
    providerUrl: "required",
  },
  {
    id: "cognito",
    name: "Cognito",
    docs: docsLink("cognito"),
    providerUrl: "required",
  },
  {
    id: "github",
    name: "GitHub",
    docs: docsLink("github"),
    providerUrl: "restricted",
  },
  {
    id: "gitlab",
    name: "GitLab",
    docs: docsLink("gitlab"),
    providerUrl: "allowed",
  },
  {
    id: "google",
    name: "Google",
    docs: docsLink("google"),
    providerUrl: "restricted",
  },
  {
    id: "azure",
    name: "Microsoft Entra ID",
    docs: docsLink("azure"),
    providerUrl: "required",
  },
  {
    id: "oidc",
    name: "OIDC",
    // we don't currently have a docs page specifically for this
    docs: docsLink("identity-providers"),
    providerUrl: "required",
  },
  {
    id: "okta",
    name: "Okta",
    docs: docsLink("okta"),
    providerUrl: "required",
  },
  {
    id: "onelogin",
    name: "OneLogin",
    docs: docsLink("one-login"),
    providerUrl: "required",
  },
  {
    id: "ping",
    name: "Ping Identity",
    docs: docsLink("ping"),
    providerUrl: "required",
  },
];

// for efficient lookup of names, docs, etc
export const IdentityProvidersLookup: Map<string, IdentityProvider> =
  IdentityProviders.reduce(
    (m, p) => m.set(p.id, p),
    new Map<string, IdentityProvider>(),
  );
